import { useApi } from "@utils/useApi";
import { EcommerceShoppingCartClient } from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";
import ms from "ms";
import { CART_PRODUCT_AVAILABILITY_QUERY_KEY } from "@features/unified-user-header-feature/utils/HeaderQueryKeys";

interface CartProductAvailabilityQueryOptions {
  staleTime?: number;
}

/**
 * Fetches per-item stock availability for the supplied cart product ids
 * (ShoppingCartDto.itemId). Callers enable it only while their surface needs current
 * availability and there is at least one id. Map results by `itemId`; a missing item
 * means availability is unknown rather than out of stock.
 */
export const useGetCartProductAvailability = (
  itemIds: number[],
  enabled: boolean,
  options?: CartProductAvailabilityQueryOptions,
) => {
  const api = useApi(EcommerceShoppingCartClient);
  const ids = [...new Set(itemIds)].sort((a, b) => a - b);

  return useQuery({
    queryKey: [CART_PRODUCT_AVAILABILITY_QUERY_KEY, ids],
    queryFn: () => api.getCartItemAvailability(ids),
    enabled: enabled && ids.length > 0,
    staleTime: options?.staleTime ?? ms("5m"),
  });
};

export default useGetCartProductAvailability;
